import {
    FETCH_NOTES_REQUEST,
      FETCH_NOTES_SUCCESS,
      FETCH_NOTES_FAILURE,
    } from "./FetchNotesTypes";
    import api from "../../utils/Api";
    
    export const fetchNotesRequest = () => {
      return {
        type: FETCH_NOTES_REQUEST,
      };
    };
    
    export const fetchNotesSuccess = (notesList) => {
      return {
        type: FETCH_NOTES_SUCCESS,
        payload: notesList,
      };
    };
    
    export const fetchNotesFailure = (error) => {
      return {
        type: FETCH_NOTES_FAILURE,
        payload: error,
      };
    };
    
    export const fetchNotesListing = () => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "dashboard/notes/fetch";
    
      
      return async (dispatch) => {
        dispatch(fetchNotesRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const notesList = response.data.data;
          dispatch(fetchNotesSuccess(notesList));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchNotesFailure(errorMsg));
        }
      };
    };
    